import Courses from '../Courses';
import CoursesCreate from '../Views/CoursesCreate';
import CoursesUpdate from '../Views/CoursesUpdate';
import CoursesTable from '../Views/CoursesTable';

const CoursesRoute =
    {
        path: '/academic-courses',
        meta: {
            name: {
                en: 'Courses',
                es: 'Cursos'
            }
        },
        component: Courses,
        children:[
            {
                path:'',
                component: CoursesTable,
                meta: { name: 'Index', group: 'portaladministrativo.academic', path: 'courses', permission: 'READ' }
            },
            {
                path:'create',
                component: CoursesCreate,
                meta: { name: 'Create Course', group: 'portaladministrativo.academic', path: 'courses', permission: 'CREATE' }
            },
            {
                path: 'update/:id',
                component: CoursesUpdate,
                meta: { name: 'Update Course', group: 'portaladministrativo.academic', path: 'courses', permission: 'READ' }
            },
        ]
    };

export default CoursesRoute
